import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { graphqlRequest } from "context/graphql/functions";
import { AppAsyncThunkConfig } from "store";
import { State } from "./comments.store";

export const createAppAsyncThunk = createAsyncThunk.withTypes<AppAsyncThunkConfig>();

export const asyncQueries = {
  getNotifications: createAppAsyncThunk(
    "notifications/getNotifications",
    async (_, { rejectWithValue, extra: { sdk } }) => {
      const { data, errors } = await graphqlRequest(sdk.getCommentNotifications);
      if (errors) return rejectWithValue(errors);
      if (!data?.commentNotifications) return rejectWithValue("something went wrong");
      return data;
    },
  ),
  getMentionables: createAppAsyncThunk(
    "notifications/getMentionables",
    async (_, { rejectWithValue, extra: { sdk } }) => {
      const { data, errors } = await graphqlRequest(sdk.getCommentMentionables);
      if (errors) return rejectWithValue(errors);
      if (!data?.commentMentionables) return rejectWithValue("something went wrong");
      return data;
    },
  ),
};

export const queryBuilder = (builder: ActionReducerMapBuilder<State>) => {
  builder.addCase(asyncQueries.getNotifications.pending, (state) => {
    state.loading = true;
    return state;
  });
  builder.addCase(asyncQueries.getNotifications.rejected, (state) => {
    state.loading = false;
    return state;
  });
  builder.addCase(asyncQueries.getNotifications.fulfilled, (state, { payload: data }) => {
    state.loading = false;
    state.notifications = [...data.commentNotifications];
    return state;
  });
  builder.addCase(asyncQueries.getMentionables.pending, (state) => {
    state.mentionsLoading = true;
    return state;
  });
  builder.addCase(asyncQueries.getMentionables.rejected, (state) => {
    state.mentionsLoading = false;
    return state;
  });
  builder.addCase(asyncQueries.getMentionables.fulfilled, (state, { payload: data }) => {
    state.mentionsLoading = false;
    state.mentionables = {
      users: [...(data.commentMentionables?.users ?? [])],
      teams: [...(data.commentMentionables?.teams ?? [])],
      technicians: [...(data.commentMentionables?.technicians ?? [])],
      defaultMainServiceTeam: data.commentMentionables?.defaultMainServiceTeam ?? false,
      defaultTaskCreator: data.commentMentionables?.defaultTaskCreator ?? false,
      mainServiceTeamCode: data.commentMentionables?.mainServiceTeamCode,
    };
    return state;
  });
};
